import { useLeague } from '@/feature/league-hub-sbk/hooks/use-league';

import { findNavigationSport } from '../utils/navigation-launchpad-utils';
import { useNavigationEntries } from './use-navigation-entries';

export const useLeagueSport = (leagueId: string) => {
    const { data: entries } = useNavigationEntries();
    const { data: league } = useLeague(leagueId);
    return (entries && findNavigationSport(entries, leagueId)) ?? league?.sport;
};
